import { Menu, MenuItem } from '@material-ui/core'
import { CirclePlus } from 'lucide-react'
import PropTypes from 'prop-types'
import React from 'react'
import { useStyles } from './style'
// 1. Importando o componente padronizado
import EmojiOptions from '../EmojiOptions'

const mostUsedEmojis = ['👍', '❤️', '😂', '😮', '😢', '👏']

const ChatMessageReactionsMenu = ({
  message,
  menuOpen,
  handleClose,
  anchorEl,
  onAddReaction
}) => {
  const classes = useStyles()

  const [showFullPicker, setShowFullPicker] = React.useState(false)

  if (!message) return null

  const handleReact = emojiData => {
    const emoji = typeof emojiData === 'string' ? emojiData : emojiData.native

    if (!message || !message.id) {
      console.error('Mensagem não encontrada para adicionar reação')
      return
    }

    onAddReaction(emoji, message)

    // 2. RESETAR OS ESTADOS AO REAGIR
    setShowFullPicker(false)
    handleClose()
  }

  return (
    <Menu
      keepMounted
      className={classes.menu}
      open={menuOpen}
      onClose={handleClose}
      anchorReference="anchorPosition"
      anchorPosition={
        anchorEl &&
        anchorEl.mouseX !== undefined &&
        anchorEl.mouseY !== undefined
          ? { top: anchorEl.mouseY, left: anchorEl.mouseX }
          : undefined
      }
      elevation={0}
    >
      <MenuItem>
        <div className={classes.flexContainer}>
          {/* Emojis rápidos */}
          {mostUsedEmojis.map((emoji, index) => (
            <div
              key={index}
              className={classes.emojiButton}
              onClick={() => handleReact(emoji)}
            >
              {emoji}
            </div>
          ))}

          <div
            className={classes.emojiButtonMenu}
            onClick={e => e.stopPropagation()}
          >
            <EmojiOptions
              disabled={false}
              handleAddEmoji={handleReact}
              // 3. PASSE O ESTADO E O SETTER CORRETAMENTE
              showEmoji={showFullPicker}
              setShowEmoji={setShowFullPicker}
              position="floating"
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  cursor: 'pointer'
                }}
              >
                <CirclePlus size={20} />
              </div>
            </EmojiOptions>
          </div>
        </div>
      </MenuItem>
    </Menu>
  )
}

ChatMessageReactionsMenu.propTypes = {
  message: PropTypes.object.isRequired,
  menuOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  anchorEl: PropTypes.object,
  onAddReaction: PropTypes.func.isRequired
}

export default ChatMessageReactionsMenu
